import { render, staticRenderFns } from "./PhoneScreenMain1.vue?vue&type=template&id=707e8ee2&scoped=true&"
import script from "./PhoneScreenMain1.vue?vue&type=script&lang=js&"
export * from "./PhoneScreenMain1.vue?vue&type=script&lang=js&"
import style0 from "./PhoneScreenMain1.vue?vue&type=style&index=0&id=707e8ee2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707e8ee2",
  null
  
)

export default component.exports